import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ColDef } from 'ag-grid-community';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { CasingTypeModel, DrillingEquipmentModel } from '../../../../../form-controls/components/new-casing-plan/models/casing-plan.model';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-casing-and-tubing',
    templateUrl: './casing-and-tubing.component.html',
    styleUrls: ['./casing-and-tubing.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class CasingAndTubingComponent extends ApplicationSectionBaseComponent implements OnInit {



	@Input() form: FormGroup;
	@Input() application: WorkflowData;

	toolTypes: DrillingEquipmentModel[] = [];
	subscription: Subscription = new Subscription();

	@Input() dataTypes: CasingTypeModel[] = [];

	columns: any[] = [
		{ name: 'Wellbore Diameter', id: "WD" },
		{ name: 'Casing Diameter', id: "CAD" },
		{ name: 'Collar Diameter', id: "CD" },
		{ name: 'Feet Installed', id: "FI" },
		{ name: 'Feet Left In Well', id: "FLIW" },
		{ name: 'Cement Volume(sacks)', id: "CV" },
		{ name: 'Cement Top', id: 'CT' },
		{ name: 'Grade', id: 'G' },
		{ name: 'Weight', id: 'W' },
		{ name: 'Burst Pressure Rating', id: 'BPR' },
		{ name: 'Bottom', id: 'BOT' },
		{ name: 'Tool Type', id: 'TT' }

	]

	reviewStates: ApplicationState[] = [
		ApplicationState.VerifyCompletion,
		ApplicationState.InitialReview,
		ApplicationState.InitialApproval,
		ApplicationState.FinalApproval
	];

	blankToolType: DrillingEquipmentModel = {
		code: "",
		definition: "",
		isActive: true,
		isRequired: false,
		lastModifiedDateUTC: new Date
	}


	get isInternal(): boolean {
		return this._auth.User.isInternal;
	}

	constructor(public _auth: AuthService, public domainService: DomainDefinitionService) { super(_auth) }

	ngOnInit() {
		let obs$: Observable<DrillingEquipmentModel[]> = this.domainService.getDrillingEquipment().pipe(
			tap((models: DrillingEquipmentModel[]) => {
				this.toolTypes = models;
				this.toolTypes.unshift(this.blankToolType);
			})

		);

		let subs$: Subscription = obs$.subscribe()
		this.subscription.add(subs$);
		if (this.application != null) {
			if (this.application.applicationState == (ApplicationState.InitialReview || ApplicationState.Approved)) {
				this.form.disable()
			}
		}

	}

	getFieldName(code: string, section: string): string {
		return `casingTubing|${code}|${section}`;
	}

}
